export const USERS_CHARTS_REQUEST = "USERS_CHARTS_REQUEST";
export const USERS_CHARTS_SUCCESS = "USERS_CHARTS_SUCCESS";
export const USERS_CHARTS_FAILURE = "USERS_CHARTS_FAILURE";
